import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import clsx from 'clsx';
import MuiCardActionArea from '@material-ui/core/CardActionArea';
import { combineClasses, combineProps, omit, overridableStyled, useThemeProps, } from '../../../foundation';
import { useRcCardContext } from '../Card/CardContext';
import { CardActionAreaStyle } from './styles';
import { RcCardActionAreaClasses, RcCardActionAreaRippleClasses, } from './utils';
var _RcCardActionArea = forwardRef(function (inProps, ref) {
    var _a;
    var props = useThemeProps({ props: inProps, name: 'RcCardActionArea' });
    var _b = useThemeProps({ props: props, name: 'MuiButtonBase' }), classNameProp = _b.className, classesProp = _b.classes, TouchRipplePropsProp = _b.TouchRippleProps, onFocusVisible = _b.onFocusVisible, onBlur = _b.onBlur, disableRipple = _b.disableRipple, disableTouchRipple = _b.disableTouchRipple, rest = __rest(_b, ["className", "classes", "TouchRippleProps", "onFocusVisible", "onBlur", "disableRipple", "disableTouchRipple"]);
    var setFocusVisible = useRcCardContext().setFocusVisible;
    var events = useMemo(function () {
        return combineProps({
            onFocusVisible: function () { return setFocusVisible(true); },
            onBlur: function () { return setFocusVisible(false); },
        }, {
            onFocusVisible: onFocusVisible,
            onBlur: onBlur,
        });
    }, [onBlur, onFocusVisible, setFocusVisible]);
    var classes = useMemo(function () {
        return combineClasses(omit(RcCardActionAreaClasses, ['disableRipple']), classesProp);
    }, [classesProp]);
    var className = clsx(classNameProp, (_a = {},
        _a[RcCardActionAreaClasses.disableRipple] = disableRipple || disableTouchRipple,
        _a));
    var TouchRippleProps = useMemo(function () {
        return combineProps({ classes: RcCardActionAreaRippleClasses }, TouchRipplePropsProp);
    }, [TouchRipplePropsProp]);
    return (React.createElement(MuiCardActionArea, __assign({}, rest, events, { ref: ref, className: className, classes: classes, TouchRippleProps: TouchRippleProps, disableRipple: disableRipple, disableTouchRipple: disableTouchRipple })));
});
var RcCardActionArea = overridableStyled(_RcCardActionArea)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), CardActionAreaStyle);
RcCardActionArea.defaultProps = {};
RcCardActionArea.displayName = 'RcCardActionArea';
export { RcCardActionArea };
var templateObject_1;
